[
  {
    "keyword": "Ascend",
    "definition": "Trigger fires at start of round 7 (entire round). If played after R7 start, doesn't trigger.",
    "citation": "§7"
  },
  {
    "keyword": "Attuned",
    "definition": "Plays without spending an action (still costs energy) **when you control a card matching the specified orbital, type, or other requirement**.",
    "citation": "§7"
  },
  {
    "keyword": "Awaken",
    "definition": "Conditional effect that activates when you **seize a stone** during the current round (see §9 for compilation pattern).",
    "citation": "§7"
  },
  {
    "keyword": "Call",
    "definition": "Move **one target Wonder one realm closer** to this card's realm. The target's controller must hold a stone in that Wonder's current realm. **Note:** this is NOT the DSL `Call` op — encode with `Move` + `When` (see §9).",
    "citation": "§7"
  },
  {
    "keyword": "Celestial Counter",
    "definition": "Grants **+4 power during Ascend (round 7)**; each additional counter stacks another +4. Does **not** grant the Ascend keyword itself.",
    "citation": "§7"
  },
  {
    "keyword": "Deathstrike",
    "definition": "Wins **or ties** a battle → destroy target enemy Wonder. Counts as on-battle (resolves at §5 step 4, **before Protector Counter and Flying**). Not optional.",
    "citation": "§7"
  },
  {
    "keyword": "Deny N",
    "definition": "Opponent moves top N of their deck to Abyss.",
    "citation": "§7"
  },
  {
    "keyword": "Eternal",
    "definition": "Triggers when this card moves directly from deck to Abyss (via a Deny effect).",
    "citation": "§7"
  },
  {
    "keyword": "Faith",
    "definition": "Persistent resource (does not reset). Spend once per round; spending is a free action that uses a turn.",
    "citation": "§7"
  },
  {
    "keyword": "Flying",
    "definition": "At **end of battle**, move this Wonder to an adjacent active realm. Allows attacking multiple realms in one round.",
    "citation": "§7"
  },
  {
    "keyword": "Growth Counter",
    "definition": "Placed on a **Land**. While this counter is present, that Land is treated as a legendary Wonder with power equal to the number of lands its controller owns.",
    "citation": "§7"
  },
  {
    "keyword": "Guardian",
    "definition": "This Wonder gains +N power whenever an enemy Wonder moves into or arrives in its realm.",
    "citation": "§7"
  },
  {
    "keyword": "Harvest",
    "definition": "Tap-free action (primarily on Lands). Multiple harvests resolve simultaneously. Actions gained from Harvest cannot be spent in the same turn they were generated.",
    "citation": "§7"
  },
  {
    "keyword": "Heart of a Legend",
    "definition": "This card's printed abilities trigger **twice** while you control at least one other legendary Wonder. Multiple instances of Heart of a Legend do not stack beyond doubling.",
    "citation": "§7"
  },
  {
    "keyword": "Hoard N",
    "definition": "Active while you control N or more stones. Toggles on/off immediately as stones change hands.",
    "citation": "§7"
  },
  {
    "keyword": "Kingdom N",
    "definition": "Active while you control N or more lands (anywhere on the board, regardless of realm).",
    "citation": "§7"
  },
  {
    "keyword": "Link",
    "definition": "Establishes an orbital link for its orbital. Reduces same-orbital card costs by 1 energy. Multiple Links of the same orbital do not stack.",
    "citation": "§7"
  },
  {
    "keyword": "Null Counter",
    "definition": "Bearer's rules text is treated as blank (ability text only; stats and existing counters are unaffected).",
    "citation": "§7"
  },
  {
    "keyword": "Portal",
    "definition": "Banish + return this card immediately; it unequips, untaps, and re-triggers on-arrival abilities. Portal cards retain their origin controller and \"end of round\" effects across the portal.",
    "citation": "§7"
  },
  {
    "keyword": "Protector Counter",
    "definition": "One-time prevention of an enemy attack that would seize a stone (consumed on use). Resolves **after** Deathstrike (see §5 step 4).",
    "citation": "§7"
  },
  {
    "keyword": "Rage",
    "definition": "On arrival, attack immediately without spending an action. **Sacrifice this card after the battle.**",
    "citation": "§7"
  },
  {
    "keyword": "Seek N",
    "definition": "Reveal the top N cards of your deck; play one matching the filter for free (core requirement and orbital link requirement ignored); bury the rest.",
    "citation": "§7"
  },
  {
    "keyword": "Shield",
    "definition": "Prevents one instance of destruction or enemy targeting; one counter consumed per prevention.",
    "citation": "§7"
  },
  {
    "keyword": "Stoneseeker",
    "definition": "Creates Story tokens (see §9 for CreateToken compilation).",
    "citation": "§7"
  },
  {
    "keyword": "Stun",
    "definition": "Tap target Wonder and set its base power to 0 **until end of round**. (No \"permanent tap\" — both effects expire at round end.)",
    "citation": "§7"
  },
  {
    "keyword": "Symbiosis",
    "definition": "On arrival: copy all abilities from one allied Wonder whose power matches this card's power. Cannot copy Symbiosis itself, nor abilities that were themselves granted via Symbiosis. Symbiosis effects can chain (a copied ability that was originally granted by another Symbiosis is allowed).",
    "citation": "§7"
  },
  {
    "keyword": "Unstable",
    "definition": "Sacrifice this card at end of round.",
    "citation": "§7"
  }
]
